import React, { useState } from "react";
import { cn } from "@/lib/utils";

// Hue from the title so a book without a cover keeps the same colour everywhere.
const hueOf = (text = "") => [...text].reduce((h, c) => (h * 31 + c.codePointAt(0)) >>> 0, 7) % 360;

/**
 * A book cover at 2:3 with reserved space (no layout shift). Missing or broken
 * images fall back to a typographic cover carrying the title, so a grid never
 * shows a blank box or the browser's broken-image icon.
 */
export const BookCover = ({ src, title, className, eager = false, sizes = "(max-width: 640px) 45vw, 200px" }) => {
  const [failed, setFailed] = useState(false);
  const showImage = src && !failed;
  return (
    <div className={cn("relative aspect-[2/3] w-full overflow-hidden bg-muted [container-type:inline-size]", className)}>
      {showImage ? (
        <img
          src={src} alt={title} width="400" height="600" sizes={sizes}
          loading={eager ? "eager" : "lazy"} decoding="async"
          onError={() => setFailed(true)}
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div
          role="img" aria-label={title}
          className="absolute inset-0 flex items-center justify-center p-[8%] text-center"
          style={{ background: `linear-gradient(160deg, hsl(${hueOf(title)} 32% 34%), hsl(${(hueOf(title) + 30) % 360} 38% 22%))` }}
        >
          <span className="font-display text-[clamp(0.7rem,9cqw,1.35rem)] leading-snug text-white/90 line-clamp-5">
            {title}
          </span>
        </div>
      )}
    </div>
  );
};
